import { useContext } from 'react'
import Excel from '../../../../Assets/Modals/Excel.svg';
import Cross from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { CSVUploadContext } from '../../../../Context/CSVUploadContext';
import { closeModal } from '../../../../Features/inventoryManagementSlice';
import { postExcel } from '../../../../lib/utils/apiCalls';
import { showToast } from '../../../../Components/Toaster/Toaster';

function UploadCSV() {
    const dispatch = useDispatch();

    const { uploadedFile } = useContext(CSVUploadContext);

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const handleUpload = async () => {
        try {
            const response = await postExcel(uploadedFile);
            if(response?.response?.status === 500) {
                showToast('Error posting excel file.', 'error');
            }
            else if(response?.status === 200) {
                showToast('Excel data added.', 'success');
                handleCloseModal();
                window.location.reload();
            }
        }
        catch(err) {
            console.log(err);
        }
    }

    return (
        <div className='w-[27%] bg-[#FFFFFF] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-6'>
            <div className="flex items-center gap-2">
                <div className="size-8 flex items-center justify-center">
                    <img src={Excel} alt="" />
                </div>

                <h1 className='font-bold text-2xl text-[#121212]'>Upload your excel</h1>

                <button onClick={handleCloseModal} className="size-6 flex items-center justify-center ml-auto outline-none">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <p className='font-medium text-base text-[#808080]'>Upload the excel file.</p>

            <button onClick={handleUpload} className='outline-none w-fit rounded px-4 py-2 font-semibold text-base text-buttonText bg-primaryColor hover:bg-primaryAccent'>Upload</button>
        </div>
    );
}

export default UploadCSV;
